const list = {
  // =================================================================================================================
  components() {
    return [
      // ===========[ 날짜 관련 ]==========
      {'component': 'empty-space', "label": '[ 날짜 관련 ]'},
      {
        'component': 'search-year',
        "label": '연도',
        "value": 'year',
        "query": {'y': 'year'},
        "options": {
          default: new Date().getFullYear()
        }
      },
      {
        'component': 'search-month',
        "label": '월',
        "value": 'month',
        "query": {'y_m': 'month'},
        "options": {
          default: '1',
          lastLabel: true,
        }
      },
      {
        'component': 'search-check-group',
        "label": '',
        "value": 'half',
        "query": {'ck_l': 'checkList'},
        "options": {
          list: [{text: '상반기', value: '상반기'}, {text: '하반기', value: '하반기'}],
          selectMaxCount: 1,
          default: [],
        }
      },
      {
        'component': 'search-year-quarter',
        "label": '분기',
        "value": 'quarter',
        "query": {'y_q': 'quarter'},
        "options": {
          default: '1',
        }
      },
      {
        'component': 'search-start-end',
        "label": '작성일',
        "value": 'date',
        "query": {'ss': 'startDate', 'ee': 'endDate'},
        "options": {
          default: {sd: '', ed: ''},
        }
      },


      // ===========[ 검색형 ]==========
      {'component': 'empty-space', "label": '[ 검색형 ]'},
      {
        'component': 'search-column-keyword',
        "label": '검색조건',
        "value": 'column',
        "query": {'ck_t': 'head', 'ck_k': 'keyword'},
        "options": {hiddenList: ['Head 3']}
      },
      {
        'component': 'search-keyword',
        "label": '검색어',
        "value": 'keyword',
        "query": {'k': 'keyword'},
        "options": {
          default: '',
        }
      },


      // ===========[ 선택형 ]==========
      {'component': 'empty-space', "label": '[ 선택형 ]'},
      {
        'component': 'search-select-company-tree',
        "label": '부서명',
        "value": 'companyTree',
        "query": {'c0': 'company0', 'c1': 'company1', 'c2': 'company2'},
        "options": {
          default: { company0: null, company1: null, company2: null },
        }
      },
      {'component': 'search-disaster-types', "label": '재해형태', "value": 'disaster', "query": {'dty': 'disaster'}, "options": {}},
      {'component': 'empty-space'},
      {'component': 'search-company-ids', "value": 'companies'},


      // ===========[ 팝업 선택형 ]==========
      {'component': 'empty-space', "label": '[ 팝업 선택형 ]'},
      {
        'component': 'search-check-group',
        "label": '구분',
        "value": 'fieldCompany',
        "query": {'ck_l2': 'checkList'},
        "options": {
          list: [{text: '사업장별', value: '사업장별'}, {text: '부서별', value: '부서별'}],
          selectMaxCount: 1,
          default: [],
        }
      },
      {
        'component': 'search-select-field',
        "label": '학교명',
        "value": 'field',
        "query": {'f_id': 'fieldId', 'f_name': 'fieldName'},
        "options": {
          default: {fieldId: '', fieldName: ''},
          visibleKeyValue: [{'fieldCompany': '사업장별'}],
        }
      },
      {
        'component': 'search-select-company',
        "label": '부서명',
        "value": 'company',
        "query": {'c_id': 'companyId', 'c_name': 'companyName'},
        "options": {
          default: {companyId: '', companyName: ''},
          visibleKeyValue: [{'fieldCompany': '부서별'}],
        }
      },
      {'component': 'empty-space', "options": {line: true}},
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({key: 'body.year', operator: '=', value: search.year})
    }

    // 상반기 / 하반기
    if (search.half && search.half.length > 0) {
      conditions.push({key: 'body.구분', operator: '=', value: search.half[0]})
    }

    //  검색일
    if (search.date) {
      conditions.push({key: 'created_at', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'created_at', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  재해형태
    if (search.disaster) {
      conditions.push({key: 'body.disasterList[%]', operator: 'LIKE', value: `%${search.disaster}%`})
    }

    //  검색조건
    const heads = list.getHead().map(e => { return {[e.name] : e.key} });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {name: '학교명', key: 'body.stdInfo.field_name'},
      {name: 'Head 2', key: 'body.합계.편성액'},
      {name: 'Head 3', key: 'body.합계.잔액'},
      {name: 'Head 4', key: 'body.stdInfo.department'},
      {name: 'Head 5', key: 'body.stdInfo.com_name'},
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return '학교명'
      case 1:
        return 'Column 2'
      case 2:
        return 'Column 3'
      case 3:
        return 'Column 4'
      case 4:
        return 'Column 5'
      }
    } catch (e) { /*ignore*/
    }
    return ''
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}

export default list;
